import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Table from "../shared/table/Table";
import { FiEye, FiEdit3, FiTrash2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";

const BilisselBecerilerTable = () => {
  const [rows, setRows] = useState([]);
   const [usage,  setUsage]  = useState({});  
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d = "") => translations[k] || d;

 
  const fetchData = () =>
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/skills/list`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` },
      })
      .then((r) => setRows(r.data))
      .catch(console.error);

 
  const fetchUsage = () =>
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/skills/usage-map`,
      { headers:{ Authorization:`Bearer ${localStorage.getItem("admin_token")}` } })
      .then(r => {
        const map = {};
        r.data.forEach(row => { map[row.skill_id] = Number(row.count); });
        setUsage(map);
      })
      .catch(console.error);

 
  useEffect(() => { fetchData(); fetchUsage(); }, []);


  const handleDelete = (id) => {
    confirmAlert({
      title: t("CONFIRM_DELETE_TITLE", "Silme Onayı"),
      message: t("CONFIRM_DELETE_MSG", "Bu beceriyi silmek istediğinize emin misiniz?"),
      buttons: [
        {
          label: t("YES", "Evet, sil"),
          onClick: async () => {
            try {
              await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/skills/${id}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` }
              });
              toast.success(t("DELETE_SUCCESS", "Beceri silindi."));
              fetchData();
              fetchUsage();
            } catch (e) {
              const msg = e.response?.data?.message || t("DELETE_FAILED", "Silme işlemi başarısız oldu.");
              toast.error(msg);
              console.error("❌ Silme hatası:", e);
            }
          }
        },
        {
          label: t("CANCEL", "İptal"),
          onClick: () => {}
        }
      ]
    });
  };

  /* kolonlar */
  const columns = useMemo(() => [
    { accessorKey: "id", header: () => "ID", size: 60 },

    {
      accessorKey: "image",
      header: () => t("TABLE_COVER", "Görsel"),
      enableSorting: false,
      size: 120,
      cell: (info) => {
        const val = info.getValue();
        if (!val) return null;
        const src = val.startsWith("http") ? val : `${process.env.REACT_APP_API_BASE_URL}${val}`;
        return (
          <img
            src={src}
            alt="cover"
            style={{ width: 80, height: 50, objectFit: "cover", borderRadius: 4 }}
            onError={(e) => (e.target.style.display = "none")}
          />
        );
      },
    },

    { accessorKey: "title", header: () => t("TABLE_TITLE", "Başlık") },

    {
      accessorKey: "created_at",
      header: () => t("TABLE_DATE", "Tarih"),
      cell: (info) => new Date(info.getValue()).toLocaleDateString("tr-TR"),
    },

    {
      accessorKey: "actions",
      header: () => t("ACTIONS", "İşlemler"),
      enableSorting: false,
      size: 140,
      cell: (info) => {
         const id   = info.row.original.id;
        const used = (usage[id] ?? 0) > 0;

        const delClass = used
          ? "avatar-text avatar-md text-muted bg-light border-0 cursor-not-allowed"
          : "avatar-text avatar-md text-danger bg-soft-danger border-soft-danger";

        return (
          <div className="d-flex gap-2">
            <Link to={`/skills/view/${id}`} className="avatar-text avatar-md text-primary bg-soft-primary border-soft-primary"
                                       title={t("VIEW", "Görüntüle")}>
                                        <FiEye />
            </Link>
            <Link to={`/skills/edit/${id}`} className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
                                      title={t("EDIT", "Düzenle")}>
                                        <FiEdit3 />
            </Link>
            <button
              disabled={used}
              className={delClass}
              title={used
                     ? t("SKILL_IN_USE","Bu beceri sorulara bağlı olduğu için silinemez.")
                     : t("DELETE","Sil")}
              onClick={() => !used && handleDelete(id)}
            >
              <FiTrash2/>
            </button>
          </div>
        );
      },
    },
  ], [translations, usage]);

  return <Table data={rows} columns={columns} />;
};

export default BilisselBecerilerTable;
